import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
//import api_base_url from "../../config";
import axiosInstance from "../../../../api/axiosInstance";

const initialState = {
  jobs: [],
  status: 'idle', // can be 'idle', 'loading', 'succeeded' or 'failed'
  error: null,
};

// return fetch("api/Filters/GetHCPINDStatus?country=" + obj.country).then((r) => {
//   if (r.status === 401) {
//       dispatch(endUserSession());
//     } else {
//       return r.json();
//     }


// });

export const fetchJobsInProgress = createAsyncThunk(
    'inProgressJobs/fetchJobsInProgress',
    //async ({ userId }) => {
    
  async ({ userId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/Jobs/GetJobs`, {
        params: { UserId: userId, Status: 'Open' },
        headers: {
         // Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        dispatch(endUserSession());
      }
      return rejectWithValue(
        error.response?.data || 'Failed to fetch completed jobs'
      );
    }
  }
  //   }
   );
  

const inProgressSlice = createSlice({
  name: 'inProgressJobs',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobsInProgress.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchJobsInProgress.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.jobs = action.payload;
      })
      .addCase(fetchJobsInProgress.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        state.jobs = []; 
      });
  },
});

export default inProgressSlice.reducer;
